module.exports = __webpack_public_path__ + "static/media/kdb-banner-2@2x.6c49e4ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kdb-banner-2@2x.png
// module id = 1276
// module chunks = 1